import UseReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

export default function Filters({ filters, setFilters }) {
    const {
        placeTypes,
        placeNames,
        dispatchNature,
    } = UseReportFiltersFetch ({
        fetchPlaceTypes: true,
        fetchPlaceNames: true,
        fetchDispatchNature: true,
    });

    const placeOptions = [
        { value: "NOT-INFORMED", label: "Não informado" },
        ...placeNames,
    ];

    const natureOptions = [
        { value: "NOT-INFORMED", label: "Não informado" },
        ...dispatchNature,
    ];

    return (
        <div className={`mb-2 ${minMenuHeight}`}>
            <form className="space-y-4">
                <InputDateTime
                    id="dtStart"
                    label="Data/hora inicial *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtStart ? new Date(filters.dtStart) : null}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                />
                <InputDateTime
                    id="dtEnd"
                    label="Data/hora final *"
                    dateFormat="LL"
                    classNameWrapper="w-full"
                    selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                    value={filters.placeType}
                    onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                />
                <SelectComponent
                    id="placeType"
                    label="Tipo de local"
                    classNameWrapper="w-full"
                    wrapValue={true}
                    isMulti={true}
                    options={placeTypes}
                    value={filters.placeType}
                    onChange={(value) => setFilters(prev => ({ ...prev, placeType: value }))}
                />
                <SelectComponent
                    id="place"
                    label="Local pré-cadastrado"
                    classNameWrapper="w-full"
                    wrapValue={true}
                    isMulti={true}
                    options={placeOptions}
                    value={filters.place}
                    onChange={(value) => setFilters(prev => ({ ...prev, place: value }))}
                />
                <SelectComponent
                    id="nature"
                    label="Natureza"
                    classNameWrapper="w-full"
                    wrapValue={true}
                    isMulti={true}
                    options={natureOptions}
                    value={filters.nature}
                    onChange={(value) => setFilters(prev => ({ ...prev, nature: value }))}
                />
            </form>
        </div>
    )
}